import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { router } from '@/app/router';
import { queryClient } from '@/app/query-client';
import { initSentry, SentryErrorBoundary } from '@/lib/sentry';
import '@/index.css';
import 'leaflet/dist/leaflet.css';

initSentry();

document.documentElement.classList.add('dark');

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found in index.html');
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <SentryErrorBoundary fallback={<p>Something went wrong. Refresh to retry.</p>}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </SentryErrorBoundary>
  </React.StrictMode>,
);
